import {cloneDeep as _cloneDeep} from 'lodash';
import ClientModel from "./../../models/ClientModel"
const ClientsModule = {
    namespaced: true,
    state: () => ({
        allUsers: [],
        allEvents: [],
        allClients: [],
        clients: [],
        client: _cloneDeep(ClientModel),
    }),
    getters: {
        getAllUsers (state) {
            return state.allUsers
        },
        getAllEvents (state) {
            return state.allEvents
        },
        getAllClients (state) {
            return state.allClients
        },
        getClients (state) {
            return state.clients
        },
        getClient (state) {
            return state.client
        },
    },
    mutations: {
        setAllUsers(state, payload) {
            state.allUsers = payload
        },
        setAllEvents(state, payload) {
            state.allEvents = payload
        },
        setAllClients(state, payload) {
            state.allClients = payload
        },
        setClients(state, payload) {
            state.clients = payload
        },
        setClient(state, payload) {
            state.client = payload
        },
    },
    actions: {
        setAllUsers (context, payload) {
            context.commit('setAllUsers', payload);
        },
        setAllEvents (context, payload) {
            context.commit('setAllEvents', payload);
        },
        setAllClients(context, payload) {
            context.commit('setAllClients', payload);
        },
        setClients (context, payload) {
            context.commit('setClients', payload);
        },
        setClient (context, payload) {
            context.commit('setClient', payload);
        },
    },
}

export default ClientsModule;
